import React, { useEffect, useState } from "react";
import styled from "styled-components/native";
import { Pressable } from "react-native";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { VDBIcons } from "@utils/VDBIcons";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { SearchResultListTypes } from "@components/molecules/SearchResultListItem/types";
import ImageComponentWithSummary from "@components/molecules/SearchResultListItem/ImageComponentWithSummary";
import OptionsComponentForSearchResult from "@components/molecules/SearchResultListItem/OptionsComponentForSearchResult";
import SecondSectionWithFilteredData from "@components/molecules/SearchResultListItem/SecondSectionWithFilteredData";
import PriceContainer from "@components/molecules/SearchResultListItem/PriceContainer";
import { getProductThemeFromType } from "@components/common/Header/utils";
import { useItemDetailsCardSubSections } from "../../../hooks/useSortCustomData";
import { ProductCategory } from "@utils/constants";
import { CustomisationKey } from "@scenes/pdp/types";
import { useProductPrefix } from "../../../hooks/useProductPrefix";
import SecondSectionWithFilteredPairData from "@components/molecules/SearchResultListItem/SecondSectionWithFilteredPairData";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { isLinkedPair } from "@utils/product/productValidators";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";

const SearchResultListViewComponent = ({
  listExpanded,
  mItem,
  menuOptions,
  menuOptionSelected,
  checkBoxSelection,
  ismItemChecked,
  handleItemClick,
  favoriteClickedFunction,
  productType,
  showAvailabilityDot,
  sectionName = SearchFilterTypeEnum.SINGLE_STONES,
  handleLinkClick,
}: SearchResultListTypes) => {
  const { addRouteToHistory } = useNavigationHistory();
  const theme = useTheme();
  const userInfo = useUserInfo();
  const productPrefix = useProductPrefix();
  const priceMode = userInfo?.user?.price_mode;
  const [showExpandedListView, setShowExpandedListView] =
    useState(listExpanded);
  const [isItemChecked, setIsItemChecked] = useState(false);
  const productTheme = getProductThemeFromType(productType);

  useEffect(() => {
    setIsItemChecked(mItem?.is_selected || ismItemChecked || false);
  }, [ismItemChecked, mItem?.is_selected]);

  const { priceDetailsDataOptions } =
    useItemDetailsCardSubSections(
      productType as ProductCategory,
      priceMode,
      sectionName,
      false
    ) || {};

  const filteredPriceDetailsDataOptions = priceDetailsDataOptions?.filter(
    (menuItem: any) => {
      if (
        mItem?.is_fancy &&
        menuItem?.name === CustomisationKey.discount_percent
      ) {
        return false;
      }
      return true;
    }
  );

  return (
    <Pressable
      onPress={() =>
        handleItemClick(
          mItem,
          productType,
          priceMode,
          productPrefix,
          addRouteToHistory
        )
      }
    >
      <ParentContainer theme={theme} isChecked={isItemChecked}>
        <FirstContainer>
          <ImageComponentWithSummary
            mItem={mItem}
            isCheckboxVisible={!userInfo?.isIFrame()}
            checkBoxSelection={checkBoxSelection}
            ismItemChecked={ismItemChecked}
            productType={productType}
            showAvailabilityDot={showAvailabilityDot}
            fromSearchResult={true}
            sectionName={sectionName}
          />

          <OptionsComponentForSearchResult
            mItem={mItem}
            menuOptions={menuOptions}
            menuOptionSelected={menuOptionSelected}
            favoriteClickedFunction={favoriteClickedFunction}
            productType={productType}
          />
        </FirstContainer>
        {sectionName === SearchFilterTypeEnum.PAIRS && isLinkedPair(mItem) ? (
          <SecondSectionWithFilteredPairData
            listExpanded={showExpandedListView}
            mItem={mItem}
            productType={productType}
            sectionName={sectionName}
            priceDetailsDataOptions={filteredPriceDetailsDataOptions}
            handleLinkClick={handleLinkClick}
          />
        ) : (
          <SecondSectionWithFilteredData
            listExpanded={showExpandedListView}
            mItem={mItem}
            productType={productType}
            priceDetailsDataOptions={filteredPriceDetailsDataOptions}
            handleLinkClick={handleLinkClick}
            sectionName={sectionName}
          />
        )}
        {priceMode !== PriceModes.GREEN && (
          <PriceContainer
            mItem={mItem}
            priceDetailsDataOptions={filteredPriceDetailsDataOptions}
          />
        )}
        <FourthContainer theme={theme} productTheme={productTheme}>
          <Pressable
            onPress={() => setShowExpandedListView(!showExpandedListView)}
          >
            <VDBIcon
              color={theme[`${productTheme}-06`]}
              name={
                showExpandedListView ? VDBIcons.ARROW_UP : VDBIcons.ARROW_DOWN
              }
              variant={IconsVariant.VDBCustom}
              size={24}
            />
          </Pressable>
        </FourthContainer>
      </ParentContainer>
    </Pressable>
  );
};

const ParentContainer = styled.View<any>`
  height: auto;
  width: auto;
  border-radius: 8px;
  border-color: ${({ theme, isChecked }) =>
    theme[isChecked ? "diam-04" : "core-04"]};
  border-width: ${({ isChecked }) => (isChecked ? 2 : 1)}px;
`;

const FirstContainer = styled.View<any>`
  height: 76px;
  width: auto;
  background-color: ${({ theme }) => theme["core-01"]};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-direction: row;
  justify-content: space-between;
`;

const FourthContainer = styled.View<{
  productTheme: string;
}>`
  height: 24px;
  width: auto;
  background-color: ${({ theme, productTheme }) => theme[`${productTheme}-03`]};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  align-items: center;
  justify-content: center;
`;

export default SearchResultListViewComponent;
